import React from "react"

import { Button } from "@coval/ui"
import { MessageSquare } from "lucide-react"

import { EmptyFilteredState, EmptyStateCTA } from "@/components/EmptyStateCTA"

interface UploadedConversationsEmptyStateProps {
  hasActiveFilters?: boolean
  searchValue?: string
  onRequestUpload: () => void
  onResetFilters?: () => void
}

export const UploadedConversationsEmptyState: React.FC<
  UploadedConversationsEmptyStateProps
> = ({
  onRequestUpload,
  onResetFilters,
  hasActiveFilters = false,
  searchValue = "",
}) => {
  if (hasActiveFilters || searchValue.trim()) {
    return (
      <EmptyFilteredState
        title="No conversations found"
        onReset={onResetFilters}
        resetLabel={hasActiveFilters ? "Clear filters" : "Clear search"}
      />
    )
  }
  return (
    <EmptyStateCTA
      docsHref="https://docs.coval.ai/guides/observability"
      apiDocsHref="https://docs.coval.ai/api-reference/v1/conversations/conversations/submit-conversation-for-evaluation"
      icon={MessageSquare}
      title="Upload your first conversation"
      description="Upload and evaluate your agent conversations with automated metrics."
      data-testid="uploaded-conversations-empty-state"
    >
      <Button
        variant="default"
        aria-label="Upload a conversation"
        onClick={onRequestUpload}
      >
        Upload Conversation
      </Button>
    </EmptyStateCTA>
  )
}
